/**
 * A translucent version of any CSS colour.
 *
 * Replaces appending hex alpha (`colour + "33"`), which only works on 6-digit
 * hex and fails silently on `rgb()`, on a CSS variable, or on any antd token
 * that is not literal hex — producing an invalid colour with no error.
 */
export const translucent = (color: string, alpha: number): string =>
  `color-mix(in srgb, ${color} ${Math.round(alpha * 100)}%, transparent)`;
